import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.css";
import cs from "classnames";
import { Button, Input } from "antd";
import "antd/es/input/style/css";
import "antd/es/button/style/css";
import { statTrack } from "@/utils/mtstat";

const { TextArea } = Input;

interface InAWordContentProps {
  keyword: string;
  keywordChangeHandle: (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  placeholder: string;
  enterHandle: (
    e: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => void;
  onCreate: () => void;
}

const InAWordContent = (props: InAWordContentProps) => {
  const [inputFocus, setInputFocus] = useState(false);
  const inputEle = useRef(null);
  const [showTextArea, setShowTextArea] = useState(false);
  const { keyword, keywordChangeHandle, placeholder, enterHandle, onCreate } =
    props;
  const isComposing = useRef(false);

  const handleComposition = (
    e: React.CompositionEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (e.type === "compositionstart") {
      isComposing.current = true;
    }
    if (e.type === "compositionend") {
      isComposing.current = false;
      keywordChangeHandle(
        e as unknown as React.ChangeEvent<
          HTMLInputElement | HTMLTextAreaElement
        >
      );
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (!isComposing.current) {
      keywordChangeHandle(e);
    }
  };

  useEffect(() => {
    if (keyword.length >= 30) {
      setShowTextArea(true);
    } else {
      setShowTextArea(false);
    }
  }, [keyword]);

  return (
    <div className={styles.word}>
      <div
        className={cs(styles.input, {
          focus: inputFocus,
        })}
      >
        <div
          className={styles.inputContent}
          style={{
            height: showTextArea ? "auto" : "72px",
          }}
        >
          {showTextArea ? (
            <TextArea
              ref={inputEle}
              key={keyword}
              maxLength={300}
              onChange={handleChange}
              onCompositionStart={handleComposition}
              onCompositionEnd={handleComposition}
              onKeyDown={enterHandle}
              defaultValue={keyword}
              onFocus={(v) => {
                // 光标移动到最后
                v.target.selectionStart = v.target.value.length;
                setInputFocus(true);
              }}
              rows={5}
              autoFocus={true}
              onBlur={(v) => {
                statTrack("tools_click_ppt_home", {
                  click_type: "inputbox",
                });
                setInputFocus(false);
              }}
              placeholder={placeholder}
            />
          ) : (
            <Input
              id="inAWordContentInput"
              key={keyword}
              ref={inputEle}
              maxLength={300}
              onChange={handleChange}
              onCompositionStart={handleComposition}
              onCompositionEnd={handleComposition}
              onKeyDown={enterHandle}
              defaultValue={keyword}
              onFocus={(v) => {
                // 光标移动到最后
                v.target.selectionStart = v.target.value.length;
                setInputFocus(true);
              }}
              autoFocus={true}
              onBlur={(v) => {
                statTrack("tools_click_ppt_home", {
                  click_type: "inputbox",
                });
                setInputFocus(false);
              }}
              placeholder={placeholder}
            />
          )}
          {!showTextArea ? (
            <Button data-blue type="primary" onClick={onCreate}>
              免费生成大纲
            </Button>
          ) : null}
        </div>
        {showTextArea ? (
          <div
            style={{
              textAlign: "center",
            }}
          >
            <Button
              data-blue
              type="primary"
              onClick={onCreate}
              style={{
                margin: "10px auto 0",
              }}
            >
              免费生成大纲
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default React.memo(InAWordContent);
